import React, { Component } from "react";
import StoreInformation from "./StoreInformation";
import AdMenu from "./AdMenu";

class StoreLeft extends Component {
  render() {
    return (
      <React.Fragment>
        <AdMenu />
        <StoreInformation />
      </React.Fragment>
    );
  }
}

export default StoreLeft;
